import { GENERATE_BATCH_ID_ENDPOINT } from '../config';
import { axiosAzureInstance } from '../Utils/axios';

const fetchBatchId = async (): Promise<{ batchId: string }> => {
  const { data } = await axiosAzureInstance.get(GENERATE_BATCH_ID_ENDPOINT);
  return data;
};

const BatchIdService = {
  fetchBatchId,
};

export default BatchIdService;
